(function () {
  angular.module("akitabox.mobile.services", ["akitabox.mobile.services.nav"]);
})();
